window.themeCartAddedToast = "Adicionado ao carrinho!";
(function () {
  'use strict';

  var TOAST_MS = 2400;
  var PULSE_MS = 1100;
  var msg = typeof window.themeCartAddedToast === 'string' ? window.themeCartAddedToast : 'Added to cart!';

  function cartAnchors() {
    var list = [];
    document.querySelectorAll('li.box-minicart a.push_side').forEach(function (a) {
      list.push(a);
    });
    var mobile = document.querySelector('a.footer-mini-cart.mini-cart');
    if (mobile) list.push(mobile);
    return list;
  }

  function pulseCart() {
    document.querySelectorAll('li.box-minicart').forEach(function (li) {
      li.classList.add('js-micro-cart-pulse');
      window.setTimeout(function () {
        li.classList.remove('js-micro-cart-pulse');
      }, PULSE_MS);
    });
    document.querySelectorAll('a.footer-mini-cart.mini-cart').forEach(function (a) {
      a.classList.add('js-micro-cart-pulse');
      window.setTimeout(function () {
        a.classList.remove('js-micro-cart-pulse');
      }, PULSE_MS);
    });
  }

  function showToast() {
    var anchors = cartAnchors();
    var anchor = anchors[0];
    if (!anchor) return;

    var prev = document.querySelector('.js-cart-confirm-toast');
    if (prev) prev.remove();

    var toast = document.createElement('div');
    toast.className = 'js-cart-confirm-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = msg;
    document.body.appendChild(toast);

    function place() {
      var r = anchor.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var top = r.top + window.scrollY;
      toast.style.left = cx + 'px';
      toast.style.top = top + 'px';
    }

    place();
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    var onScroll = function () {
      place();
    };
    window.addEventListener('scroll', onScroll, true);

    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.removeEventListener('scroll', onScroll, true);
      window.setTimeout(function () {
        toast.remove();
      }, 320);
    }, TOAST_MS);
  }

  function onAjaxAddToCart() {
    pulseCart();
    showToast();
  }

  document.body.addEventListener('ajax:addToCart', onAjaxAddToCart);
})();
